module.exports = __webpack_public_path__ + "assets/img/icon-triangle-up.c2751e55.png";